import profile from './profile-slice';
import deviceCpu from './cpu-slice';
import deviceGpu from './gpu-slice';

const reducers = ({profile: profile, deviceCpu: deviceCpu, deviceGpu: deviceGpu});
export default reducers;
